/**
 * 诱导 typescript 支持模版字符串中的智能解析，见
 * https://github.com/microsoft/typescript-lit-html-plugin
 * https://github.com/microsoft/typescript-styled-plugin
 */
export function transparentTag(literals, ...exp) {
    return literals.reduce((ret, literal, index) => `${ret}${literal}${exp[index] || ''}`, '');
}
//# sourceMappingURL=string.js.map